import { FunctionComponent } from 'react';
import styles from './Satellite.scss';
import React from 'react';

export interface SurfaceTemperatureLegendProps {
  layout: 's' | 'm' | 'l';
}

const VALUES = [
  { label: '<0', color: '#060528' },
  { label: '0', color: '#0f0d6d' },
  { label: '1', color: '#3a33b3' },
  { label: '2', color: '#4c479b' },
  { label: '3', color: '#6495ed' },
  { label: '4', color: '#87cdfa' },
  { label: '5', color: '#caecfa' },
  { label: '6', color: '#6ae4ac' },
  { label: '7', color: '#13db5e' },
  { label: '8', color: '#22b157' },
  { label: '9', color: '#2e892b' },
  { label: '10', color: '#3c521f' },
  { label: '11', color: '#5c7f4c' },
  { label: '12', color: '#a0a369' },
  { label: '13', color: '#eed090' },
  { label: '14', color: '#feff95' },
  { label: '15', color: '#ffe87c' },
  { label: '16', color: '#f2bb66' },
  { label: '17', color: '#ffa630' },
  { label: '18', color: '#ce821e' },
  { label: '19', color: '#eb6462' },
  { label: '20', color: '#d93835' },
  { label: '21', color: '#e42217' },
  { label: '22', color: '#8c001a' },
  { label: '>22', color: '#570212' },
];

export const SurfaceTemperatureLegend: FunctionComponent<SurfaceTemperatureLegendProps> = ({
  layout,
}) => {
  const skips = {
    s: 5,
    m: 2,
    l: 1,
  };
  return (
    <div className={styles.surfaceTemperatureLegend} aria-hidden>
      {VALUES.map((x, i) => (
        <div className={styles.legendValue} key={x.label}>
          <span
            className={styles.colorbar}
            style={{ background: x.color }}
          ></span>
          {(i - 1) % skips[layout] === 0 ? x.label : null}
        </div>
      ))}
    </div>
  );
};
